import Vue from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { BootstrapVue } from 'bootstrap-vue';
import VueIziToast from 'vue-izitoast';

import './validation';

import './assets/stylesheets/default-buttons.css';
import './assets/stylesheets/global.css';
import './assets/stylesheets/toasts.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'izitoast/dist/css/iziToast.css';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(BootstrapVue);
Vue.use(VueIziToast);

Vue.prototype.$getValidationState = ({ dirty, validated, valid = null }) => dirty || validated ? valid : null;

Vue.prototype.$getInputIcon = (value, name) => {
    let state = value !== '' ? '-fill' : '';
    return require(`images/formIcons/${name}${state}.svg`);
};

Vue.prototype.$defines = require('../libs/defines');

import { loadApp } from './app';

loadApp();

